import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./App.scss";
import DefaultLayout from "./containers/DefaultLayout/DefaultLayout";
import InterceptorService from "./services/AuthService/InterceptorService";

export default function App() {
  const [pageType, setPageType] = useState("");
  useEffect(() => {
    InterceptorService.useInterceptor();
  }, []);

  return (
    <Router>
      <Switch>
        <Route
          exact
          path="/"
          render={(props) => <DefaultLayout setPageType={setPageType} />}
        />
      </Switch>
    </Router>
  );
}
